import { AUTH0_INJECTION_KEY, Auth0Plugin, type Auth0VueClient } from '@auth0/auth0-vue'
import { ref, type App } from 'vue'

export function useMockAuth0(): Partial<Auth0VueClient> {
  // const t = useAuth0()
  const isAuthenticated = ref(true)
  const isLoading = ref(false)

  const user = ref<Auth0VueClient['user']['value']>({
    name: 'Test User',
    email: 'test@example.com'
  })

  async function getAccessTokenSilently() {
    return new Promise((resolve) => {
      resolve('mock-access-token')
    })
  }

  return {
    // ...t,
    isAuthenticated,
    isLoading,
    user,
    getAccessTokenSilently: getAccessTokenSilently as unknown as never
  }
}

export function createMockAuth0(): Partial<Auth0Plugin> {
  const isAuthenticated = ref(true)
  const isLoading = ref(false)

  async function getAccessTokenSilently(): Promise<string> {
    return new Promise((resolve) => {
      resolve('mock-access-token')
    })
  }

  const auth0 = {
    isAuthenticated,
    isLoading,
    getAccessTokenSilently: getAccessTokenSilently as unknown as never,
    install: (app: App) => {
      app.provide(AUTH0_INJECTION_KEY, useMockAuth0() as unknown as Auth0VueClient)
    }
  }
  return auth0
}
